const formatDate = (dateString: string): string => {
    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
    }
    return date.toLocaleDateString('en-US', options)
}

const annDateFormat = (dateString: string): string => {
    const date = new Date(dateString)

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are zero-based
    const year = date.getFullYear().toString()

    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const period = hours >= '12' ? 'PM' : 'AM'
    const formattedHours = (
        hours > '12' ? (parseInt(hours) - 12).toString() : hours
    ).padStart(2, '0')

    return `${month}/${day}/${year} ${formattedHours}:${minutes} ${period}`
}

export { formatDate, annDateFormat }
